import { Icon, Text, useAppTheme } from '@workwhile/ui'
import { ArrowUpIcon, ArrowDownIcon } from 'lucide-react'

export function MetricsDiff({
  value,
  direction,
}: {
  value: string
  direction: 'up' | 'down'
}) {
  const { colors } = useAppTheme()

  return (
    <Text
      fontSize="2"
      inline
      color={direction === 'up' ? colors.success200 : colors.error200}
    >
      <Icon
        icon={direction === 'up' ? ArrowUpIcon : ArrowDownIcon}
        color={direction === 'up' ? colors.success200 : colors.error200}
        size={12}
      />
      {value}
    </Text>
  )
}
